/**
 * 大六壬 · 六亲
 *
 * 以日干五行为「我」，论四课上神、三传等所处的五行关系：
 *   同我者兄弟、生我者父母、我生者子孙、克我者官鬼、我克者妻财。
 */
import { ganWuXing, ganOf, liuQinOf, zhiOf, zhiWuXing } from './constants';
/** 以日干论某地支的六亲 */
export function liuQinOfZhi(dayGanIndex, zhiIndex) {
    return liuQinOf(ganWuXing(dayGanIndex), zhiWuXing(zhiIndex));
}
/** 以日干论某天干的六亲 */
export function liuQinOfGan(dayGanIndex, targetGanIndex) {
    return liuQinOf(ganWuXing(dayGanIndex), ganWuXing(targetGanIndex));
}
/** 六亲 → 五行生克关系说明（断课文案用） */
export const LIU_QIN_RELATION = {
    父母: '生我者，主长辈、文书、庇护、房屋',
    兄弟: '同我者，主同辈、竞争、劫财、助力',
    子孙: '我生者，主小辈、喜悦、解厄、平安',
    妻财: '我克者，主财物、妻子、经营所得',
    官鬼: '克我者，主官职、夫婿、疾病、阻碍、忧患',
};
/** 日干与日支的六亲关系（判断干支生克强弱用） */
export function dayRelation(dayGanIndex, zhiIndex) {
    const qin = liuQinOfZhi(dayGanIndex, zhiIndex);
    return {
        qin,
        text: `日干${ganOf(dayGanIndex)}对${zhiOf(zhiIndex)}为${qin}（${LIU_QIN_RELATION[qin]}）`,
    };
}
//# sourceMappingURL=liuqin.js.map